import { render, staticRenderFns } from "./BanksList.vue?vue&type=template&id=66293b72&scoped=true"
import script from "./BanksList.vue?vue&type=script&lang=js"
export * from "./BanksList.vue?vue&type=script&lang=js"
import style0 from "./BanksList.vue?vue&type=style&index=0&id=66293b72&prod&lang=scss&scoped=true"
import style1 from "./BanksList.vue?vue&type=style&index=1&id=66293b72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66293b72",
  null
  
)

export default component.exports